import TokenResource from "./TokenResource";

export default class PaymentNoticesResource extends TokenResource {
	id = 0;
	activityId = 0;
	applicationNumber = 0;
	messageId = 0;
	activityInfo = "";
	datePlanned = "";
	dateSent = "";
	documentJobId = 0;

	pk() {
		return this.id.toString();
	}

	static listUrl(
		searchParams?: Readonly<Record<string, string | number>> | undefined
	) {
		if (searchParams && Object.keys(searchParams).length) {
			const { id } = searchParams;
			return `${this.urlRoot}/list/${id}`;
		}
		throw new Error(
			`Couldn't retrieve paymentNotices with backofficeApplicationId ${
				searchParams ? searchParams.id : null
			}`
		);
	}

	static urlRoot = "/api/paymentnotices";
}

export interface CollectedInvoicesAndNoticesProps {
	dueDate: string;
	dateSent: string;
	type: string;
	invoiceNumber: string;
	principalAmount: string;
	status: number;
	remainingBalance: number;
	activityInfo: string;
	documentJobId: number;
}
